import { render, staticRenderFns } from "./OverlayTitleParts.vue?vue&type=template&id=92267f00&scoped=true"
import script from "./OverlayTitleParts.vue?vue&type=script&lang=ts"
export * from "./OverlayTitleParts.vue?vue&type=script&lang=ts"
import style0 from "./OverlayTitleParts.vue?vue&type=style&index=0&id=92267f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92267f00",
  null
  
)

export default component.exports